//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { requestRoadsObjectsSearch } from '../RequestRoadsCommand/RequestRoadsCommandObjectsSearch.js'

const DEFAULT_REJECT_REOPEN_DESCRIPTION = 'Контрактом ГК №TK777/18 не предусмотрено оснований для проведения указанных в заявке видов работ'

function toReference (record) {
  const reference = {}
  for (const field of ['id', 'key', 'name', 'type']) {
    if (record[field] != null) {
      reference[field] = record[field]
    }
  }
  return reference
}

export default {
  mixins: [requestRoadsObjectsSearch],
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    serviceObjectType: {
      type: String,
      default: null
    },
    rejectReopenDescription: {
      type: String,
      default: null
    },
    rejectReopenBreakageRoads: {
      type: Object,
      default: null
    },
    rejectReopenEquipmentStatusRoads: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      description: null,
      breakageRoads: null,
      equipmentStatusRoads: null,
      faultTypesInRoadsMsk: [],
      equipmentStatesInRoadsMsk: []
    }
  },
  computed: {
    isValid: function () {
      return this.ruleRequired(this.description) &&
        this.ruleRequired(this.breakageRoads) &&
        this.ruleRequired(this.equipmentStatusRoads)
    }
  },
  watch: {
    opened: function (result) {
      if (result) {
        this.description = this.rejectReopenDescription || DEFAULT_REJECT_REOPEN_DESCRIPTION
        this.breakageRoads = this.rejectReopenBreakageRoads
        this.equipmentStatusRoads = this.rejectReopenEquipmentStatusRoads
        this.loadReferences()
      }
    }
  },
  methods: {
    ruleRequired: function (value) {
      return !!value && (typeof value !== 'string' || !!value.trim())
    },
    validateFields: function () {
      this.$refs.descriptionField.validate()
      this.$refs.breakageRoadsField.validate()
      this.$refs.equipmentStatusRoadsField.validate()
    },
    loadReferences: function () {
      this.loading = true

      Promise.all([
        this.loadFaultTypesInRoadsMsk(this.serviceObjectType),
        this.getCloseEquipmentRoadsStatuses().then((equipmentStates) => {
          this.equipmentStatesInRoadsMsk = equipmentStates || []
        })
      ]).then(() => {
        this.applyDefaultSelectedValues()
        this.$nextTick(() => {
          this.validateFields()
        })
      }).finally(() => {
        this.loading = false
      })
    },
    applyDefaultSelectedValues: function () {
      if (!this.breakageRoads) {
        this.breakageRoads = this.faultTypesInRoadsMsk.find(item => item.name === 'Прочее') || null
      }
      if (!this.equipmentStatusRoads) {
        this.equipmentStatusRoads = this.equipmentStatesInRoadsMsk.find(item => item.name === 'Работает') || null
      }
    },
    loadFaultTypesInRoadsMsk: function (serviceObjectType = null) {
      const urlParameters = [
        {
          param: 'roadsId',
          type: 'integer',
          action: 'any'
        },
        {
          param: 'serviceObjectType',
          type: 'object',
          action: 'any'
        }
      ]

      const encodedUrlParameters = encodeURI(JSON.stringify(urlParameters))
      const url = '/service/obj/search' +
                  '?params=' + encodedUrlParameters +
                  '&nameField=name' +
                  '&paramsOperation=and' +
                  '&type=breakageRoads' +
                  '&limit=100000'

      return axiosGet({
        url: url,
        onSuccess: (response) => {
          this.faultTypesInRoadsMsk = []

          if (!response.data.result) {
            return
          }

          for (const faultType of response.data.result) {
            for (const objectType of faultType['param.serviceObjectType'] || []) {
              if (serviceObjectType !== null) {
                if (objectType.key === serviceObjectType) {
                  this.faultTypesInRoadsMsk.push(toReference(faultType))
                }
              } else {
                this.faultTypesInRoadsMsk.push({
                  ...toReference(faultType),
                  name: faultType.name + ' (' + objectType.name + ')'
                })
              }
            }
          }
        },
        onFailure: 'Ошибка загрузки типов неисправностей в Roads',
        msgTarget: this
      })
    },
    onConfirm: function () {
      if (!this.isValid) {
        return
      }

      this.$emit('confirm', {
        rejectReopenDescription: this.description.trim(),
        rejectReopenBreakageRoads: this.breakageRoads,
        rejectReopenEquipmentStatusRoads: this.equipmentStatusRoads
      })
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

